<template>
	<div>
		<add-new-post
			v-if="group.permissions.status === 'accepted'"
			:group-id="group.id"
			:is-group-admin="isGroupAdmin"
			@postAdded="postAdded"
		/>
		<div class="bold mb-3">Aktywność w grupie</div>
			<div v-if="posts.length">
				<v-lazy
					v-for="(post, i) in posts"
					:key="`group-post-${post.id}-${i}`"
					v-model="isActive[i]"
					:options="{ threshold: 0 }"
					:transition="null"
					min-height="100"
				>
					<div v-if="i === posts.length - 2 && typeof isActive[i] !== 'undefined'" v-intersect="{
						handler: infiniteScrolling,
						options: {
							threshold: [0.5]
						}
					}"></div>
					<post
						:post="post"
						:route-is-group="true"
					/>
				</v-lazy>
				<div v-for="i in 3" :key="i">
					<v-skeleton-loader
						v-if="loading"
						type="card"
						class="mt-4"
						height="150"
					></v-skeleton-loader>
				</div>
			</div>
			<div v-else class="text-muted">
				Brak postów
			</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Post from "@/components/wall/post/Post";
import AddNewPost from "@/components/wall/AddNewPost";

export default {
	name: "GroupActivities",
	components: {
		Post,
		AddNewPost
	},
	data () {
		return {
			isActive: [true],
			loading: false,
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user',
			posts: 'groups/groupPosts',
			meta: 'groups/groupPostsMeta',
			group: 'groups/group'
		}),
		isGroupAdmin() {
			if(this.group && this.group.admins && this.group.admins.length) {
				const idx = this.group.admins.findIndex(x => x.id == this.user.id);
				if(idx != -1) {
					return true;
				}
			}
			return false;
		},
	},
	methods: {
		...mapActions('groups', [
			'getGroupPosts',
		]),
		// ...mapMutations('groups', [
		// 	'appendGroupPost'
		// ]),
		postAdded() {
			let params = {
				page: 1
			}
			this.getGroupPosts({params})
		},
		async infiniteScrolling(entries, observer, isIntersecting) {
			if (isIntersecting) {
				if (this.meta.current_page < this.meta.last_page && !this.loading) {
					this.loading = true
					let params = {
						page: this.meta.current_page + 1
					}
					await this.getGroupPosts({ params })
					this.loading = false
				}
			}
		},
	},
	beforeDestroy() {
		this.$store.commit('groups/clearGroupPosts')
	}
}
</script>

<style scoped>

</style>
